import { Matrix4 } from 'three'
import { SEAT_HEIGHT_DEFAULT_CM, SEAT_HEIGHT_TALL_CM } from './seatHeightCatalog'

/** Desplazamiento local Y por cm de altura de asiento (47 - 42 = 5 cm → 50 mm). */
export const SEAT_HEIGHT_LOCAL_Y_PER_CM_MM = 10

export function isSeatOrCushionLinkedSon(item: any): boolean {
  if (!item || item.type !== 'linkedSon') return false
  const ref = String(item.catalogID || item.referencia || '').toLowerCase()
  return ref.includes('asiento') || ref.includes('cojin')
}

function normalizeSeatHeightCm(value: unknown): number {
  return Number(value) === SEAT_HEIGHT_TALL_CM ? SEAT_HEIGHT_TALL_CM : SEAT_HEIGHT_DEFAULT_CM
}

/**
 * Posición local Y objetivo de asiento/cojín según altura de asiento.
 * En 42 el draw inicial deja todo en y=0; en 47 sube 5 cm (50 mm).
 */
export function targetSeatCushionLocalY(seatHeightCm: unknown): number {
  const height = normalizeSeatHeightCm(seatHeightCm)
  if (height === SEAT_HEIGHT_DEFAULT_CM) return 0
  return (height - SEAT_HEIGHT_DEFAULT_CM) * SEAT_HEIGHT_LOCAL_Y_PER_CM_MM
}

export function applySeatCushionLocalY(localY: number): {
  x: number
  y: number
  z: number
  matrix: Matrix4
} {
  const y = Number.isFinite(localY) ? localY : 0
  return {
    x: 0,
    y,
    z: 0,
    matrix: new Matrix4().setPosition(0, y, 0),
  }
}

export function placementForSeatHeight(seatHeightCm: unknown) {
  return applySeatCushionLocalY(targetSeatCushionLocalY(seatHeightCm))
}

export function placementForSeatHeightChange(seatHeightCm: unknown) {
  return applySeatCushionLocalY(targetSeatCushionLocalY(seatHeightCm))
}
